export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            position: 'relative'
        },
        WidgetTileBlockTitleStyle: {
            marginTop: { base: 2 }
        },
        tileCtasWrapper: {
            display: 'flex',
            gap: 2
        }
    })
}
